var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ttops"},[_c('div',{staticClass:"zuo"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"you",on:{"click":_vm.moban}},[_c('i',{staticClass:"el-icon-download"}),_vm._v(" 下载"+_vm._s(!_vm.istu? '表格':'图片')+" "),_c('div',{staticClass:"xian"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }